export const actionTypes = {
    DASHBOARD_ASSETS_PER_BRANCH_SUCCESS: 'DASHBOARD_ASSETS_PER_BRANCH_SUCCESS',
    DASHBOARD_ASSETS_PER_BRANCH_FAILURE: 'DASHBOARD_ASSETS_PER_BRANCH_FAILURE',
    DASHBOARD_ASSETS_PER_BRANCH_REQUEST: 'DASHBOARD_ASSETS_PER_BRANCH_REQUEST',

    BRANCH_LIST_REQUEST : 'BRANCH_LIST_REQUEST',
    BRANCH_LIST_SUCCESS : 'BRANCH_LIST_SUCCESS',
    BRANCH_LIST_FAILURE : 'BRANCH_LIST_FAILURE',

    EXCLUSION_REASON_REQUEST : 'EXCLUSION_REASON_REQUEST',
    EXCLUSION_REASON_SUCCESS : 'EXCLUSION_REASON_SUCCESS',
    EXCLUSION_REASON_FAILURE : 'EXCLUSION_REASON_FAILURE',

    STOCK_DATA_REQUEST : 'STOCK_DATA_REQUEST',
    STOCK_DATA_SUCCESS : 'STOCK_DATA_SUCCESS',
    STOCK_DATA_FAILURE : 'STOCK_DATA_FAILURE',

}
export const actionCreators = {
    getBranchesRequest : () => ({
        type: actionTypes.DASHBOARD_ASSETS_PER_BRANCH_REQUEST,
        info : "Get Data Request"
    }),
    getBranchesSuccess : (action) => ({
        type: actionTypes.DASHBOARD_ASSETS_PER_BRANCH_SUCCESS,
        info : "Get Data Success",
        payload : action
    }),
    getBranchesFailure : (error) => ({
        type: actionTypes.DASHBOARD_ASSETS_PER_BRANCH_FAILURE,
        info : "Get Data Fail",
        payload: error
    }),
    getBranchListRequest : ()=>({
        type: actionTypes.BRANCH_LIST_REQUEST,
        info : "Get Branches Request"
    }),
    getBranchListSuccess : (action)=> ({
        type: actionTypes.BRANCH_LIST_SUCCESS,
        info : "Get Branches Success",
        payload: action
    }),
    getBranchListFailure : (error)=>({
        type: actionTypes.BRANCH_LIST_FAILURE,
        info : "Get Branches Failure",
        payload: error

    }),
    getExclusionReasonsRequest : ()=>({
        type: actionTypes.EXCLUSION_REASON_REQUEST,
        info : "Get Branches Request"
    }),
    getExclusionReasonSuccess : (action)=> ({
        type: actionTypes.EXCLUSION_REASON_SUCCESS,
        info : "Get Branches Success",
        payload: action
    }),
    getExclusionReasonsFailure : (error)=>({
        type: actionTypes.EXCLUSION_REASON_FAILURE,
        info : "Get Branches Failure",
        payload: error

    }),
    getStockDataRequest : ()=>({
        type: actionTypes.STOCK_DATA_REQUEST,
        info : "Get Branches Request"
    }),
    getStockDataReasonSuccess : (action)=> ({
        type: actionTypes.STOCK_DATA_SUCCESS,
        info : "Get Branches Success",
        payload: action
    }),
    getStockDataFailure : (error)=>({
        type: actionTypes.STOCK_DATA_FAILURE,
        info : "Get Branches Failure",
        payload: error

    })



};

export default {
  create: actionCreators,
  type: actionTypes
};
